/* eslint-disable */
import React, { useMemo } from "react";
import Header from "../../Header/Header";
import DataTable from "../DataTable/DataTable";
import { history } from "../../../config/stores";
import exportIcon from "../../../assets/icons/export_file_icon.svg";
import * as XLSX from "xlsx";
import moment from "moment";
import "./SentToUsersList.scss";

// Mock rows for the table (no API yet)
const useMockRows = () =>
  useMemo(
    () => [
      {
        _id: "u1",
        fullName: "Alice Johnson",
        country: "Bulgaria",
        city: "Sofia",
        os: "ios",
        role: "owner",
      },
      {
        _id: "u2",
        fullName: "Marco Rossi",
        country: "Italy",
        city: "Milan",
        os: "android",
        role: "tenant",
      },
      {
        _id: "u3",
        fullName: "Franz Müller",
        country: "Germany",
        city: "Berlin",
        os: "android",
        role: "communityManager",
      },
      {
        _id: "u4",
        fullName: "Elena Petrova",
        country: "Bulgaria",
        city: "Varna",
        os: "ios",
        role: "landlordWithTenant",
      },
      {
        _id: "u5",
        fullName: "John Smith",
        country: "UK",
        city: "London",
        os: "android",
        role: "tenantWithoutLandlord",
      },
    ],
    []
  );

// Column helpers
const capFirst = (v) => (v ? v.charAt(0).toUpperCase() + v.slice(1) : "---");
const rolePretty = (r) => {
  if (!r) return "---";
  const map = {
    owner: "Owner",
    landlord: "Landlord",
    tenant: "Tenant",
    landlordWithTenant: "Landlord with Tenant",
    landlordWithoutTenant: "Landlord without Tenant",
    tenantWithoutLandlord: "Tenant without Landlord",
    communityManager: "Community Manager",
  };
  return map[r] || capFirst(r);
};

const SentToUsersList = () => {
  const rows = useMockRows();

  const data = useMemo(
    () => ({
      docs: rows,
      totalPages: 1,
      page: 1,
      totalDocs: rows.length,
      hasNextPage: false,
    }),
    [rows]
  );

  const columns = useMemo(
    () => [
      { key: "fullName", header: "Name", width: "20%", render: (v) => v || "---" },
      { key: "country", header: "Country", width: "20%", render: (v) => v || "---" },
      { key: "city", header: "City", width: "20%", render: (v) => v || "---" },
      { key: "os", header: "OS", width: "15%", render: (v) => (v ? capFirst(v) : "---") },
      { key: "role", header: "Role", width: "25%", render: (v) => rolePretty(v) },
    ],
    []
  );

  const onExport = () => {
    const wb = XLSX.utils.book_new();
    const headers = ["Name", "Country", "City", "OS", "Role"];
    const rowsAoA = rows.map((u) => [
      u.fullName || "---",
      u.country || "---",
      u.city || "---",
      u.os ? capFirst(u.os) : "---",
      rolePretty(u.role),
    ]);
    XLSX.utils.book_append_sheet(
      wb,
      XLSX.utils.aoa_to_sheet([headers, ...rowsAoA]),
      "Sent to Users"
    );
    const filename = `sent-to-users-${moment().format("DD-MM-YYYY")}.xlsx`;
    XLSX.writeFile(wb, filename);
  };

  return (
    <>
      <Header />
      <div className="main-container">
        <div className="inner-header-container">
          <div className="left-part">
            <div
              className="close-icon"
              onClick={() => history.push("/")}
              title="Back to Dashboard"
            >
              ×
            </div>
            <div className="inner-title">SENT TO USERS</div>
          </div>
          <div className="right-part">
            <div className="export-icon-container">
              <img
                src={exportIcon}
                alt="Export"
                className="export-icon-styles"
                onClick={onExport}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
        </div>
        <div className="body-container">
          <DataTable
            data={data}
            columns={columns}
            loading={false}
            features={{
              infiniteScroll: false,
              filtering: false,
              sorting: false,
              rowSelection: false,
              bulkActions: false,
              export: false,
              search: false,
            }}
            tableWidth="100%"
            defaultColumnWidth="20%"
            className=""
            emptyState={{ text: "No recipients found", image: null }}
          />
        </div>
      </div>
    </>
  );
};

export default SentToUsersList;
